<template>
	<div>
		<p v-if="formatted_address">
			{{ formatted_address }}
		</p>
		<v-responsive :aspect-ratio="16/9">
			<div ref="map" style="width: 100%; height: 100%"></div>
		</v-responsive>
	</div>
</template>

<script>
	import _ from 'lodash';

	export default {
		props: {
			options: {
				type: Object,
				default: () => ({
					zoom: 0,
					center: {
						lat:0, 
						lng:0,
					},
					fullscreenControl: false,
					streetViewControl: false,
					mapTypeControl: false,
				})
			},
			location: {
				default: null,
			},
		},

		data: () => ({
			map: null,
			google: null,
		}),

		computed: {
			zoom: function() {
				let zoom = 16;
				if (this.$props.location.country) zoom = 8;
				if (this.$props.location.state) zoom = 9; 
				if (this.$props.location.locality) zoom = 10; 
				if (this.$props.location.sublocality) zoom = 12;
				if (this.$props.location.route) zoom = 14; 
				if (this.$props.location.street_number) zoom = 16;
				return zoom;
			},
			formatted_address: function() {
				return _.get(this.$props.location, 'formatted_address', null);
			}
		},

		mounted: function()
		{
			this.$google.then((google) => {
				let element = this.$refs.map;
				this.google = google;
				this.map = new google.maps.Map(element, this.$props.options);
				let position = {
					lat: this.$props.location.lat,
					lng: this.$props.location.lng,
				}
				// Set center...
				this.map.setCenter(position);
				this.map.setZoom(this.zoom);
				// Add marker...
				let marker = new google.maps.Marker({
		            position: position,
		        });
				marker.setMap(this.map);
			})
		},

	}
</script>